<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <v-radio-group
                class="body-2"
                :value="value"
                :outline="outline"
                type="radio"
                :rules="[
                    (v) =>
                        v === 0 || v === 1 || v === -1 || $t('base.errors.requiredField'),
                ]"
                :data-meta-id="metadata.id"
                :name="metadata.name"
                :id="metadata.name"
                @change="emitValue"
            >
                <div class="question" v-html="Question" />
                <v-radio :label="$t('base.yes')" :value="1" />
                <v-radio :label="$t('base.no')" :value="0" />
                <v-radio :label="$t('base.iDontKnow')" :value="-1" />
            </v-radio-group>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';

export default {
    name: 'phx-covid-received-positive-pcr-test',
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: Number, required: true },
        withIcon: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            selected: null,
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        Question() {
            return (
                (this.required ? '* ' : '') +
        this.$t('form.phxCovidReceivedPositivePcrTestQuestion')
            );
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.border::v-deep {
    border: 2px solid var(--v-primary-base)!important;
    border-radius: 4px!important;
}
.v-radio label {
  font-size: 14px;
}

.v-radio.selected label {
  color: black;
}

.v-input--radio-group label {
  font-size: 14px;
}
.hint {
  font-size: 14px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.84);
}
.question {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.64);
  margin-bottom: 1rem;
  font-weight: 200;
}
strong{
    font-weight: bold !important;
}
</style>
